// extracted by mini-css-extract-plugin
export default {"productBanner":"ProductsBanner_productBanner__KSqlv","textPart":"ProductsBanner_textPart__p2sxk","imgPart":"ProductsBanner_imgPart__gZT2T"};